import React, { useEffect, useState, useRef } from 'react'
import { GridControlBar } from '@gravitate-js/excalibrr'
import { MetricComparison } from './MetricComparison/MetricComparison'
import { MetricGrid } from './MetricGrid/MetricGrid'
import { getCurrentDataSet, getRecents } from './util'
import { PageControls } from './PageControls/PageControls'
import { hierarchyItems } from './constants'
import api from '@utils/api'
export function Analytics() {
  const [gridData, setGridData] = useState()
  const [driverData, setDriverData] = useState()
  const [comparisonAverages, setComparisonAverages] = useState()
  const [viewMetricBy, setViewMetricBy] = useState(hierarchyItems.DRIVERS)
  const [selectedRows, setSelectedRows] = useState([])
  const [comparisonKey, setComparisonKey] = useState(`${hierarchyItems.DEPOTS}_name`)
  const [gridDataPoints, setGridDataPoints] = useState([])
  const [comparisonDataPoints, setComparisonDataPoints] = useState([])
  const [showingChart, setShowingChart] = useState(false)
  const [periodDates, setPeriodDates] = useState([])
  const [selectedPeriodDates, setSelectedPeriodDates] = useState([])
  const [loadingDatesInput, setLoadingDatesInput] = useState(false)
  const [dataLoading, setDataLoading] = useState(false)
  const gridAPIRef = useRef()
  const queryMetrics = (drivers) => {
    const dataObjects = getCurrentDataSet(viewMetricBy, drivers)
    const metricRecents = getRecents(dataObjects.baseDataSet, dataObjects.baseDateKey)
    const averageRecents = getRecents(dataObjects.averageSet, 'date')
    return { dataObjects, metricRecents, averageRecents }
  }
  const setMetricsToState = (dataObjects, metricRecents, averageRecents) => {
    setComparisonDataPoints(dataObjects.averageSet)
    setGridDataPoints(dataObjects.baseDataSet)
    setGridData(metricRecents.map((item) => ({ ...item, id: item.id || crypto.randomUUID() })))
    setComparisonAverages(averageRecents)
    setComparisonKey(dataObjects.comparisonKey)
    setLoadingDatesInput(false)
    setDataLoading(false)
  }
  const initializeComparisons = (drivers) => {
    const { dataObjects, metricRecents, averageRecents } = queryMetrics(drivers)
    setMetricsToState(dataObjects, metricRecents, averageRecents)
  }
  useEffect(() => {
    api.getAnalyticMetadata().then((resp) => {
      setPeriodDates(resp.data.periods_dates)
      const mostRecentFiveDates = resp.data.periods_dates.slice(-5)
      setSelectedPeriodDates(mostRecentFiveDates)
    })
  }, [])

  const clearData = () => {
    setGridData([])
    setDriverData(null)
    setComparisonAverages(null)
    setGridDataPoints([])
    setComparisonDataPoints([])
    setLoadingDatesInput(false)
    setDataLoading(false)
  }

  useEffect(() => {
    gridAPIRef.current?.deselectAll()
    setDataLoading(true)
    if (selectedPeriodDates.length === 0) {
      clearData()
    } else {
      api.getDriverAnalytics(selectedPeriodDates).then((resp) => {
        const capNames = (name) => {
          if (!name) return
          const names = name?.split(' ')
          return names
            .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
            .join(' ')
            .trim()
        }
        const add = resp.data.map((item) => ({
          ...item,
          productivity: { ...item.productivity, loaded_volume: item.loaded_volume, gallons: item.loaded_volume },
          supervisor_name: capNames(item.supervisor_name),
          supervisor_id: capNames(item.supervisor_id),
        }))
        setDriverData(add)
        initializeComparisons(add)
      })
    }
  }, [selectedPeriodDates])

  useEffect(() => {
    if (!driverData) return
    if (selectedRows.length !== 0) {
      setSelectedRows([])
    }
    setDataLoading(true)
    initializeComparisons(driverData)
  }, [viewMetricBy])

  return (
    <div className='flex-1 vertical-flex'>
      <div
        style={{ height: showingChart ? '350px' : window.innerWidth < 1960 ? '50px' : '60px', transition: '1s ease' }}
        className='vertical-flex metric-grid-controlbar-wrapper'
      >
        <GridControlBar
          title='Driver Metrics'
          rowCount={gridData?.length}
          actionButtons={
            <PageControls
              selectedPeriodDates={selectedPeriodDates}
              setViewMetricBy={setViewMetricBy}
              viewMetricBy={viewMetricBy}
              setShowingChart={setShowingChart}
              gridAPIRef={gridAPIRef}
              periodDates={periodDates}
              setSelectedPeriodDates={setSelectedPeriodDates}
              clearData={clearData}
              setLoadingDatesInput={setLoadingDatesInput}
              loadingDatesInput={loadingDatesInput}
            />
          }
        />
        {comparisonAverages && (
          <MetricComparison
            gridData={gridData}
            dataPoints={gridDataPoints}
            selectedRows={selectedRows}
            viewMetricBy={viewMetricBy}
            comparisonAverages={comparisonAverages}
            comparisonDataPoints={comparisonDataPoints}
            comparisonKey={comparisonKey}
          />
        )}
      </div>
      <div className=' flex-1'>
        <MetricGrid
          setSelectedRows={setSelectedRows}
          comparisonKey={comparisonKey}
          gridData={gridData}
          comparisonAverages={comparisonAverages}
          viewMetricBy={viewMetricBy}
          gridAPIRef={gridAPIRef}
          dataLoading={dataLoading}
        />
      </div>
    </div>
  )
}
